import { render, staticRenderFns } from "./DomainsTable.vue?vue&type=template&id=7f9cfd5e&"
import script from "./DomainsTable.vue?vue&type=script&lang=js&"
export * from "./DomainsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7f9cfd5e')) {
      api.createRecord('7f9cfd5e', component.options)
    } else {
      api.reload('7f9cfd5e', component.options)
    }
    module.hot.accept("./DomainsTable.vue?vue&type=template&id=7f9cfd5e&", function () {
      api.rerender('7f9cfd5e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Services/Hosting/Shared/Domains/ZoneEditor/DomainsTable.vue"
export default component.exports